/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudArrowUploadIcon16Light = forwardRef('NetCloudArrowUploadIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M3.75 4.25v.02a.5.5 0 0 1-.44.499A2.626 2.626 0 0 0 3.55 10h.95a.5.5 0 1 1 0 1h-1a3.625 3.625 0 0 1-.732-7.148 4.25 4.25 0 0 1 8.107-1.35A4.25 4.25 0 0 1 10.75 11h-.25a.5.5 0 0 1 0-1h.25a3.25 3.25 0 1 0-.184-6.495.5.5 0 0 1-.499-.333A3.252 3.252 0 0 0 3.75 4.25Z" }),
        React.createElement("path", { d: "m8 5.566 2.135 2.3a.5.5 0 1 0 .733-.68L8.599 4.741a1.5 1.5 0 0 0-2.198 0L4.132 7.185a.5.5 0 0 0 .733.68L7 5.567V14.5a.5.5 0 0 0 1 0V5.566Z" })));
});
